import { normalize } from "normalizr";
import { camelizeKeys } from "humps";
import api from "./api";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { COMMAND_EXECUTION_ERROR } from "actions/eventTypes/index";
import { sendHttpCommandAndWaitForEvent, sendHttpRequest } from "../../actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import schemas from "utils/schemas";
import { showEvent } from "actions/actionCreators/snackbarActions";
import { getPartnerLogsCached } from "./selectors";
import { combineKeys } from "utils/functions";

export function loadPartnerTypes() {
  return async (dispatch, getState) => {
    const partnerTypes = getState().entities.partnerTypes;
    if (partnerTypes) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerTypes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.partnerTypes));

      dispatch({
        type: actionTypes.LOAD_PARTNER_TYPES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function getPartnerNationalityId(uniqueId, isExternal = false) {
  return () => api.getPartnerNationalityId(uniqueId, isExternal);
}

export function loadPersons(search) {
  //no redux cache
  return () => api.getPersons(search);
}

export function loadSegregatedPersons(search) {
  //no redux cache
  return () => api.getSegregatedPersons(search);
}

export function loadPartners(search) {
  //no redux cache
  return () => api.getPartners(search);
}

export function exportPartners(filters) {
  return dispatch => {
    return api.exportPartners(filters).catch(err => {
      dispatch(showError(err.message));
    });
  };
}

export function loadActivityFieldsTypes(search) {
  return () => api.getActivityFieldsTypes(search);
}
export function loadPositions() {
  return async (dispatch, getState) => {
    const positions = getState().entities.positions;
    if (positions) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getPositions()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.positions));

      dispatch({
        type: actionTypes.LOAD_POSITIONS_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_POSITIONS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadContactModes() {
  return async (dispatch, getState) => {
    const contactModes = getState().entities.contactModes;
    if (contactModes) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getContactModes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.contactModes));

      dispatch({
        type: actionTypes.LOAD_CONTACT_MODES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CONTACT_MODES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCitizenships() {
  return async (dispatch, getState) => {
    const citizenships = getState().entities.citizenships;
    if (citizenships) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getCitizenships()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.citizenships));

      dispatch({
        type: actionTypes.LOAD_CITIZENSHIPS_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CITIZENSHIPS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadGenderTypes() {
  return async (dispatch, getState) => {
    const genderTypes = getState().entities.genderTypes;
    if (genderTypes) return;

    try {
      const response = await dispatch(sendHttpRequest(api.getGenderTypes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.genderTypes));

      dispatch({
        type: actionTypes.LOAD_GENDER_TYPES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_GENDER_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPersonDocumentTypes() {
  return async (dispatch, getState) => {
    const personDocumentTypes = getState().entities.personDocumentTypes;
    if (personDocumentTypes) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getPersonDocumentTypes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.personDocumentTypes));

      dispatch({
        type: actionTypes.LOAD_PERSON_DOCUMENT_TYPES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PERSON_DOCUMENT_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadMaritalStatuses() {
  return async (dispatch, getState) => {
    const maritalStatuses = getState().entities.maritalStatuses;
    if (maritalStatuses) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getMaritalStatuses()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.maritalStatuses));

      dispatch({
        type: actionTypes.LOAD_MARITAL_STATUSES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_MARITAL_STATUSES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadSpecialRelations() {
  return async (dispatch, getState) => {
    const specialRelations = getState().entities.specialRelations;
    if (specialRelations) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getSpecialRelations()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.specialRelations));

      dispatch({
        type: actionTypes.LOAD_SPECIAL_RELATIONS_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SPECIAL_RELATIONS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadLegalForms() {
  return async (dispatch, getState) => {
    const legalForms = getState().entities.legalForms;
    if (legalForms) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getLegalForms()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.legalForms));

      dispatch({
        type: actionTypes.LOAD_LEGAL_FORMS_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LEGAL_FORMS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartner(partnerId, partnerTypeId) {
  return async (dispatch, getState) => {
    const partner = getState().partners.items[partnerId];
    let shouldCallApi = !partner || (!partner.loaded && !partner.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_PARTNER_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartner(partnerId, partnerTypeId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.partner));
      dispatch({
        type: actionTypes.LOAD_PARTNER_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerDetails(uniqueID, addShareholders = false) {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_STARTED, key: uniqueID });

    try {
      let response;
      if (addShareholders) response = await dispatch(sendHttpRequest(api.getPartnerDetailsWithShareholder(uniqueID)));
      else response = await dispatch(sendHttpRequest(api.getPartnerDetails(uniqueID)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.shareholderDetails));

      dispatch({
        type: actionTypes.LOAD_PARTNER_DETAILS_SUCCEEDED,
        key: uniqueID,
        ...payload
      });
      return response;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_FAILED, key: uniqueID, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCountries() {
  return async (dispatch, getState) => {
    const countries = getState().entities.countries;
    if (countries) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getCountries()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.countries));

      dispatch({
        type: actionTypes.LOAD_COUNTRIES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_COUNTRIES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCounties(countryId) {
  return async (dispatch, getState) => {
    const counties = getState().entities.counties;
    const countiesByCountry = counties ? Object.values(counties).filter(x => x.parentId === countryId) : null;
    if (countiesByCountry && countiesByCountry.length !== 0) {
      return countiesByCountry;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getCounties(countryId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.counties));

      dispatch({
        type: actionTypes.LOAD_COUNTIES_SUCCEEDED,
        ...payload
      });

      return payload.entities.counties;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_COUNTIES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCities(countyId) {
  return async (dispatch, getState) => {
    const cities = getState().entities.cities;
    const citiesByCounty = cities ? Object.values(cities).filter(x => x.parentId === countyId) : null;
    if (citiesByCounty && citiesByCounty.length !== 0) {
      return citiesByCounty;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getCities(countyId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.cities));

      dispatch({
        type: actionTypes.LOAD_CITIES_SUCCEEDED,
        ...payload
      });

      return payload.entities.cities;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CITIES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAddressTypes() {
  return async (dispatch, getState) => {
    const addressTypes = getState().entities.addressTypes;
    if (addressTypes) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getAddressTypes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.addressTypes));

      dispatch({
        type: actionTypes.LOAD_ADDRESS_TYPES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_ADDRESS_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadBankAccounts(partnerId) {
  return async (dispatch, getState) => {
    const bankAccounts = getState().bankAccounts.list[partnerId];
    let shouldCallApi = !bankAccounts || (!bankAccounts.loaded && !bankAccounts.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_BANK_ACCOUNTS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getBankAccounts(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.bankAccount]));
      dispatch({
        type: actionTypes.LOAD_BANK_ACCOUNTS_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_BANK_ACCOUNTS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerBankAccountsSummary(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const bankAccountsSummary = getState().summary.bankAccountsSummary[partnerId];
    let shouldCallApi = !bankAccountsSummary || !bankAccountsSummary.loaded;

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerBankAccountsSummary(partnerId)));

      dispatch({
        type: actionTypes.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_SUCCEEDED,
        id: partnerId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerActivityFields(partnerId) {
  return async (dispatch, getState) => {
    const activityFields = getState().activityFields.list[partnerId];
    let shouldCallApi = !activityFields || (!activityFields.loaded && !activityFields.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_ACTIVITY_FIELDS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getActivityFields(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.activityFields]));
      dispatch({
        type: actionTypes.LOAD_ACTIVITY_FIELDS_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_ACTIVITY_FIELDS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerActivityFieldsSummary(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const activityFieldsSummary = getState().summary.activityFieldsSummary[partnerId];
    let shouldCallApi = !activityFieldsSummary || !activityFieldsSummary.loaded;

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerActivityFieldsSummary(partnerId)));

      dispatch({
        type: actionTypes.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_SUCCEEDED,
        id: partnerId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerContactMode(partnerId) {
  return async (dispatch, getState) => {
    const partnerContactModes = getState().partnerContactModes.list[partnerId];
    let shouldCallApi = !partnerContactModes || (!partnerContactModes.loaded && !partnerContactModes.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_PARTNER_CONTACT_MODES_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerContactModes(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.partnerContactMode]));
      dispatch({
        type: actionTypes.LOAD_PARTNER_CONTACT_MODES_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_CONTACT_MODES_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadContactInfos(partnerId) {
  return async (dispatch, getState) => {
    const contactInfos = getState().contactInfos.list[partnerId];
    let shouldCallApi = !contactInfos || (!contactInfos.loaded && !contactInfos.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_CONTACT_INFOS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getContactInfos(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.contactInfo]));
      dispatch({
        type: actionTypes.LOAD_CONTACT_INFOS_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CONTACT_INFOS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerContactInfoSummary(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const contactInfoSummary = getState().summary.contactInfoSummary[partnerId];
    let shouldCallApi = !contactInfoSummary || !contactInfoSummary.loaded;

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_CONTACT_INFO_SUMMARY_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerContactInfoSummary(partnerId)));

      dispatch({
        type: actionTypes.LOAD_PARTNER_CONTACT_INFO_SUMMARY_SUCCEEDED,
        id: partnerId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_CONTACT_INFO_SUMMARY_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadAddressList(partnerId) {
  return async (dispatch, getState) => {
    const addresses = getState().addresses.list[partnerId];
    let shouldCallApi = !addresses || (!addresses.loaded && !addresses.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_ADDRESS_LIST_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getAddressList(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.address]));
      dispatch({
        type: actionTypes.LOAD_ADDRESS_LIST_SUCCEEDED,
        key: partnerId,
        ...payload
        //payload: { entities: payload.entities, addresses: payload.result }
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_ADDRESS_LIST_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerAddressesSummary(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const partnerAddressesSummary = getState().summary.partnerAddressesSummary[partnerId];
    let shouldCallApi = !partnerAddressesSummary || !partnerAddressesSummary.loaded;

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_ADDRESSES_SUMMARY_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerAddressesSummary(partnerId)));

      dispatch({
        type: actionTypes.LOAD_PARTNER_ADDRESSES_SUMMARY_SUCCEEDED,
        id: partnerId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_ADDRESSES_SUMMARY_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadShareholders(partnerId) {
  return async (dispatch, getState) => {
    const shareholders = getState().shareholders.list[partnerId];
    let shouldCallApi = !shareholders || (!shareholders.loaded && !shareholders.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_SHAREHOLDERS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getShareholders(partnerId)));
      const camelizedJson = camelizeKeys(response);

      const shareholderDetails = camelizedJson.map(item => {
        return {
          partnerId: item.shareHolderPartnerId,
          uniqueID: item.uniqueID,
          partnerName: item.shareHolderPartnerName,
          phoneNumber: item.shareHolderPhoneNumber,
          shareholders: item.shareholders
        };
      });

      const payload = Object.assign({}, normalize(camelizedJson, [schemas.shareholder]));

      const shareholderDetailPayLoad = Object.assign({}, normalize(shareholderDetails, [schemas.shareholderDetails]));

      dispatch({
        type: actionTypes.LOAD_SHAREHOLDERS_SUCCEEDED,
        key: partnerId,
        ...payload
      });

      dispatch({
        type: actionTypes.LOAD_PARTNERS_DETAILS_SUCCEEDED,
        ...shareholderDetailPayLoad
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SHAREHOLDERS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadProperties(partnerId) {
  return async (dispatch, getState) => {
    const properties = getState().properties.list[partnerId];
    let shouldCallApi = !properties || (!properties.loaded && !properties.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_PROPERTIES_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getProperties(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.property]));
      dispatch({
        type: actionTypes.LOAD_PROPERTIES_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PROPERTIES_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadCurrencies() {
  return async (dispatch, getState) => {
    const currencies = getState().entities.currencies;
    if (currencies) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getCurrencies()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.currencies));

      dispatch({
        type: actionTypes.LOAD_CURRENCIES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CURRENCIES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadBankAccountTypes() {
  return async (dispatch, getState) => {
    const bankAccountTypes = getState().entities.bankAccountTypes;
    if (bankAccountTypes) {
      return;
    }

    try {
      const response = await dispatch(sendHttpRequest(api.getBankAccountTypes()));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.bankAccountTypes));

      dispatch({
        type: actionTypes.LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_BANK_ACCOUNT_TYPES_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadBanks(search) {
  //no redux cache
  return () => api.getBanks(search);
}

export function loadConsents(partnerId) {
  return async (dispatch, getState) => {
    const consents = getState().consents.list[partnerId];
    let shouldCallApi = !consents || (!consents.loaded && !consents.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_PARTNER_CONSENTS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getConsents(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, [schemas.consent]));
      dispatch({
        type: actionTypes.LOAD_PARTNER_CONSENTS_SUCCEEDED,
        key: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_CONSENTS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPropertyDetails(propertyId) {
  return async (dispatch, getState) => {
    const propertyDetails = getState().properties.list[propertyId];
    if (propertyDetails) {
      return propertyDetails;
    }

    dispatch({ type: actionTypes.LOAD_PROPERTY_DETAILS_STARTED, propertyId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPropertyDetails(propertyId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.propertyDetails));
      dispatch({
        type: actionTypes.LOAD_PROPERTY_DETAILS_SUCCEEDED,
        propertyId,
        ...payload
      });
      return response;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PROPERTY_DETAILS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveCompany(company, partner, callback = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_COMPANY_STARTED,
      payload: { company },
      partnerId: company.partnerId
    });
    dispatch(sendHttpRequest(api.saveCompany(company)))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.COMPANY_UPDATED);
        if (event) {
          const { partnerHierarchyDetail } = event.eventBody.partner;
          const { partnerId } = event.eventBody.partner;

          dispatch({ type: actionTypes.UPDATE_COMPANY_SUCCEEDED, partnerId: partnerId });
          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, payload: { partner }, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });

          callback(partnerHierarchyDetail, partnerId);
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_COMPANY_FAILED,
            payload: { company, error: event },
            partnerId: company.partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_COMPANY_FAILED,
          payload: { company, error },
          partnerId: company.partnerId
        });
        const errorMessage = error.errors && error.errors.length > 0 ? error.errors[0].message : error.message;
        dispatch(showError(errorMessage));
      });
  };
}

export function saveIndividual(person, partner, callback = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_INDIVIDUAL_STARTED,
      payload: { person },
      partnerId: person.partnerId
    });
    dispatch(sendHttpRequest(api.saveIndividual(person), "saveIndividual"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.INDIVIDUAL_UPDATED);
        if (event) {
          const { partnerHierarchyDetail } = event.eventBody.partner;
          const { partnerId } = event.eventBody.partner;

          dispatch({ type: actionTypes.UPDATE_INDIVIDUAL_SUCCEEDED, partnerId: partnerId });
          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, payload: { partner }, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });


          callback(partnerHierarchyDetail, partnerId);
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_INDIVIDUAL_FAILED,
            payload: { person, error: event },
            partnerId: person.partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_INDIVIDUAL_FAILED,
          payload: { person, error },
          partnerId: person.partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function uploadOCRFile(formData, progressCallback) {
  return async dispatch => {
    const event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        api.uploadOCRFile(formData, progressCallback),
        "UploadDocument",
        eventTypes.OFFER_OCR_FILE_UPLOADED
      )
    ).then(result => {
      if (result && result.eventType === eventTypes.OFFER_OCR_FILE_UPLOADED) return result.eventBody;
      else return result;
    });

    return event;
  };
}

export function loadClientByIdCard(file, partnerId, finishedOCRCallback = () => {}, updateProgress = () => {}) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.LOAD_CLIENT_BY_CARD_STARTED, payload: {} });
      const event = await dispatch(
        uploadOCRFile({ file }, progress => {
          updateProgress(progress);
        })
      );
      if (!event || event.eventType === COMMAND_EXECUTION_ERROR) {
        dispatch({ type: actionTypes.LOAD_CLIENT_BY_CARD_FAILED, payload: {} });
        finishedOCRCallback();
      } else {
        dispatch({
          type: actionTypes.LOAD_CLIENT_BY_CARD_SUCCEEDED,
          payload: {
            ocrResponse: event,
            partnerId: partnerId
          }
        });
        return event;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: actionTypes.LOAD_CLIENT_BY_CARD_FAILED, payload: {} });
      finishedOCRCallback();
    }
  };
}

export function consumeAddressFromOCR() {
  return async dispatch => {
    dispatch({ type: actionTypes.CONSUME_ADDRESS_FROM_OCR });
  };
}

export function saveProperties(partnerId, properties, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_PROPERTIES_STARTED,
      payload: { ...properties },
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveProperties(partnerId, properties), "saveProperties"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.PROPERTIES_UPDATED);

        if (event) {
          const camelizedJson = camelizeKeys(properties);
          const payload = Object.assign({}, normalize(camelizedJson, [schemas.property]));
          const { partnerId } = event.eventBody;
          dispatch({
            type: actionTypes.UPDATE_PROPERTIES_SUCCEEDED,
            key: partnerId,
            entities: payload.entities,
            ids: payload.result
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_PROPERTIES_FAILED,
            payload: { properties, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_PROPERTIES_FAILED,
          payload: { properties, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function savePartnerLogo(partnerId, partnerLogo, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_LOGO_STARTED,
      payload: { ...partnerLogo },
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.savePartnerLogo(partnerId, partnerLogo), "saveLogo"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.LOGO_UPDATED);
        if (event) {
          const { partnerId } = event.eventBody;
          dispatch({
            type: actionTypes.UPDATE_LOGO_SUCCEEDED,
            payload: partnerLogo,
            key: partnerId
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_LOGO_FAILED,
            payload: { partnerLogo, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_LOGO_FAILED,
          payload: { partnerLogo, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveAddresses(partnerId, partnerAddresses, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_ADDRESS_STARTED,
      payload: partnerAddresses,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveAddresses(partnerId, partnerAddresses), "saveAddresses"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.ADDRESS_UPDATED);
        if (event) {
          const addressIds = event.eventBody.partnerAddresses.map(item => {
            return item.partnerAddressId;
          });
          dispatch({
            type: actionTypes.UPDATE_ADDRESS_SUCCEEDED,
            partnerAddresses: event.eventBody.partnerAddresses,
            partnerId: partnerId,
            ids: addressIds
          });
          dispatch(showEvent({ ...event, ok: true }));
          callbackFn();
        } else {
          dispatch({
            type: actionTypes.UPDATE_ADDRESS_FAILED,
            payload: { partnerAddresses, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_ADDRESS_FAILED,
          payload: { partnerAddresses, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveBankAccounts(partnerId, bankAccounts, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_BANK_ACCOUNTS_STARTED,
      payload: bankAccounts,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveBankAccounts(partnerId, bankAccounts), "saveBankAccounts"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.BANK_ACCOUNTS_UPDATED);
        if (event) {
          const bankAccountIds = event.eventBody.bankAccountItemsSaved.map(item => {
            return item.bankAccountId;
          });
          dispatch({
            type: actionTypes.UPDATE_BANK_ACCOUNTS_SUCCEEDED,
            bankAccounts: event.eventBody.bankAccountItemsSaved,
            partnerId: partnerId,
            ids: bankAccountIds
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_BANK_ACCOUNTS_FAILED,
            payload: { bankAccounts, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_BANK_ACCOUNTS_FAILED,
          payload: { bankAccounts, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function savePartnerActivityFields(partnerId, activityFields, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_ACTIVITY_FIELDS_STARTED,
      payload: activityFields,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveActivityFields(partnerId, activityFields), "saveActivityFields"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.ACTIVITY_FIELDS_UPDATED);
        if (event) {
          const activityFieldsIds = event.eventBody.activityFields.map(item => {
            return item.partnerActivityFieldId;
          });

          let items = event.eventBody.activityFields
            .filter(x => activityFields.some(y => y.partnerActivityFieldId === x.partnerActivityFieldId))
            .map(item => {
              return {
                ...activityFields.filter(x => x.partnerActivityFieldId === item.partnerActivityFieldId)[0],
                ...item
              };
            });

          items = [
            ...items,
            ...activityFields
              .filter(x => x.partnerActivityFieldId === undefined)
              .map(item => {
                return {
                  ...event.eventBody.activityFields.filter(x => x.activityFieldId === item.activityFieldId)[0],
                  activityFieldName: item.activityFieldName,
                  activityFieldCode: item.activityFieldCode
                };
              })
          ];
          dispatch({
            type: actionTypes.UPDATE_ACTIVITY_FIELDS_SUCCEEDED,
            activityFields: items,
            partnerId: partnerId,
            ids: activityFieldsIds
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_ACTIVITY_FIELDS_FAILED,
            payload: { activityFields, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_ACTIVITY_FIELDS_FAILED,
          payload: { activityFields, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveContactModes(partnerId, contactModes, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_CONTACT_MODES_STARTED,
      payload: contactModes,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveContactModes(partnerId, contactModes), "saveContactModes"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.CONTACT_MODES_UPDATED);
        if (event) {
          const contactInfoModesIds = event.eventBody.contactModeItemsSaved.map(item => {
            return item.partnerContactModeId;
          });
          dispatch({
            type: actionTypes.UPDATE_CONTACT_MODES_SUCCEEDED,
            contactInfoModes: event.eventBody.contactModeItemsSaved,
            partnerId: partnerId,
            ids: contactInfoModesIds
          });
          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_CONTACT_MODES_FAILED,
            payload: { contactModes, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_CONTACT_MODES_FAILED,
          payload: { contactModes, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveContactInfos(partnerId, contactInfos, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_CONTACT_INFOS_STARTED,
      payload: contactInfos,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveContactInfos(partnerId, contactInfos), "saveContactInfos"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.CONTACT_INFOS_UPDATED);
        if (event) {
          dispatch({
            type: actionTypes.UPDATE_CONTACT_INFOS_SUCCEEDED,
            key: partnerId
          });

          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_CONTACT_INFOS_FAILED,
            payload: { contactInfos, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
        const contactModesInvalidatedEvent = result.events.find(
          x => x.eventType === eventTypes.INVALIDATE_PARTNER_CONTACT_MODES
        );
        if (contactModesInvalidatedEvent) {
          dispatch({
            type: actionTypes.PARTNER_CONTACT_MODES_INVALIDATED,
            key: partnerId
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_CONTACT_INFOS_FAILED,
          payload: { contactInfos, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveShareholders(partnerId, shareholders, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_SHAREHOLDERS_STARTED,
      payload: shareholders,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveShareholders(partnerId, shareholders), "saveShareholders"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.SHAREHOLDERS_UPDATED);
        if (event) {
          const shareholderIds = event.eventBody.shareholders.map(item => {
            return item.partnerShareHolderId;
          });
          dispatch({
            type: actionTypes.UPDATE_SHAREHOLDERS_SUCCEEDED,
            shareholders: event.eventBody.shareholders,
            partnerId: partnerId,
            ids: shareholderIds
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_SHAREHOLDERS_FAILED,
            payload: { shareholders, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_SHAREHOLDERS_FAILED,
          payload: { shareholders, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveConsents(partnerId, consents, callbackFn = () => {}) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_CONSENTS_STARTED,
      payload: consents,
      partnerId: partnerId
    });
    dispatch(sendHttpRequest(api.saveConsents(partnerId, consents), "saveConsents"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.CONSENTS_UPDATED);
        if (event) {
          const consentIds = event.eventBody.consents.map(item => {
            return item.consentTypeId;
          });
          dispatch({
            type: actionTypes.UPDATE_CONSENTS_SUCCEEDED,
            consents: event.eventBody.consents,
            partnerId: partnerId,
            ids: consentIds
          });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_CONSENTS_FAILED,
            payload: { consents, error: event },
            partnerId: partnerId
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_CONSENTS_FAILED,
          payload: { consents, error },
          partnerId: partnerId
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function loadScoringGrids(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const scoringGrid = getState().scoringGrid.list[partnerId];
    let shouldCallApi = !scoringGrid || (!scoringGrid.loaded && !scoringGrid.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_SCORING_GRIDS_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getScoringGrids(partnerId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.scoringGrid));
      dispatch({
        type: actionTypes.LOAD_SCORING_GRIDS_SUCCESS,
        id: partnerId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SCORING_GRIDS_FAILED, id: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
export function loadScoringCategoryOptions() {
  return async (dispatch, getState) => {
    let { scoringCategoryOptions } = getState().dictionaries;
    if (scoringCategoryOptions.isLoaded) {
      return;
    }

    try {
      const options = await dispatch(sendHttpRequest(api.getScoringCategoryOptions()));
      dispatch({ type: actionTypes.LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS, payload: options });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadDimensionPeriods() {
  return async (dispatch, getState) => {
    let { dimensionPeriods } = getState().dictionaries;
    if (dimensionPeriods.isLoaded) {
      return;
    }

    try {
      dimensionPeriods = await dispatch(sendHttpRequest(api.getDimensionPeriods()));
      dispatch({ type: actionTypes.LOAD_DIMENSION_PERIODS_SUCCESS, payload: dimensionPeriods });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerShareholdersSummary(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;

    const shareholdersSummary = getState().summary.shareholdersSummary[partnerId];
    let shouldCallApi = !shareholdersSummary || !shareholdersSummary.loaded;

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_STARTED, id: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getShareholdersSummary(partnerId)));
      dispatch({
        type: actionTypes.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_SUCCEEDED,
        id: partnerId,
        payload: response
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_SHAREHOLDERS_SUMMARY_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function buildPartnerExportDownloadUrl(filePath, fileName) {
  return () => api.buildPartnerExportDownloadUrl(filePath, fileName);
}

export function loadDealers(partnerId) {
  return async (dispatch, getState) => {
    if (!partnerId) return;
    const dealers = getState().partners.dealers[partnerId];
    let shouldCallApi = !dealers || (!dealers.loaded && !dealers.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_DEALERS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(api.getDealers(partnerId)));
      const payload = { partnerId, dealers: camelizeKeys(response) };
      const nPayload = Object.assign({}, normalize(payload, schemas.partner));
      dispatch({ type: actionTypes.LOAD_DEALERS_SUCCEEDED, key: partnerId, ...nPayload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DEALERS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export const loadPartnerLogsKey = (filters, pageSize) => {
  return JSON.stringify({ ...filters, pageSize });
};

export function loadPartnerLogs(filters, page, pageSize) {
  return async (dispatch, getState) => {
    const { loading, loaded } = getPartnerLogsCached(filters, page, pageSize, getState());
    let shouldCallApi = !loaded && !loading;
    if (!shouldCallApi || filters?.startDate?.includes("_") || filters?.endDate?.includes("_")) return;

    const key = loadPartnerLogsKey(filters, pageSize);
    dispatch({ type: actionTypes.LOAD_PARTNER_LOGS_STARTED, key, page, pageSize });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerLogs(filters, page, pageSize)));
      const camelizedJson = camelizeKeys(response.values);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.partnerLogs));

      dispatch({
        type: actionTypes.LOAD_PARTNER_LOGS_SUCCEEDED,
        key,
        page,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_LOGS_FAILED, key, page, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadPartnerLog(partnerLogId) {
  return async (dispatch, getState) => {
    const partnerLog = getState().partnerLogs.items[partnerLogId];
    let shouldCallApi = !partnerLog || (!partnerLog.loaded && !partnerLog.loading);
    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_PARTNER_LOG_STARTED, key: partnerLogId });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerLog(partnerLogId)));
      const camelizedJson = camelizeKeys(response);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.partnerLog));
      dispatch({
        type: actionTypes.LOAD_PARTNER_LOG_SUCCEEDED,
        key: partnerLogId,
        ...payload
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_LOG_FAILED, key: partnerLogId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDealerContactModes(partnerId, dealerId) {
  return async (dispatch, getState) => {
    const key = combineKeys(partnerId, dealerId);
    const partnerDealerContactModes = getState().partners?.dealerContactModes[key];
    const shouldCallApi =
      !partnerDealerContactModes || (!partnerDealerContactModes.loaded && !partnerDealerContactModes.loading);
    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_DEALER_CONTACT_MODES_STARTED, key });
    try {
      const response = await dispatch(sendHttpRequest(api.getDealerContactModes(partnerId, dealerId)));
      const partnerDealer = { partnerId, dealerId, contactModes: camelizeKeys(response) };
      const payload = Object.assign({}, normalize(partnerDealer, schemas.partnerDealer));
      dispatch({ type: actionTypes.LOAD_DEALER_CONTACT_MODES_SUCCEEDED, key, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DEALER_CONTACT_MODES_FAILED, key, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDealerContactInfos(partnerId, dealerId) {
  return async (dispatch, getState) => {
    const key = combineKeys(partnerId, dealerId);
    const partnerDealerContactInfos = getState().partners?.dealerContactInfos[key];
    let shouldCallApi =
      !partnerDealerContactInfos || (!partnerDealerContactInfos.loaded && !partnerDealerContactInfos.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({
      type: actionTypes.LOAD_DEALER_CONTACT_INFOS_STARTED,
      key
    });
    try {
      const response = await dispatch(sendHttpRequest(api.getDealerContactInfos(partnerId, dealerId)));
      const partnerDealer = { partnerId, dealerId, contactInfos: camelizeKeys(response) };
      const payload = Object.assign({}, normalize(partnerDealer, schemas.partnerDealer));
      dispatch({ type: actionTypes.LOAD_DEALER_CONTACT_INFOS_SUCCEEDED, key, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DEALER_CONTACT_INFOS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveDealerContactModes(partnerId, dealerId, dealerContactModes, callbackFn = () => {}) {
  return async dispatch => {
    const key = combineKeys(partnerId, dealerId);
    dispatch({
      type: actionTypes.UPDATE_DEALER_CONTACT_MODES_STARTED,
      payload: dealerContactModes,
      key: key
    });
    dispatch(sendHttpRequest(api.saveDealerContactModes(partnerId, dealerContactModes), "saveDealerContactModes"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.DEALER_CONTACT_MODES_UPDATED);
        if (event) {
          const dealerContactModesIds = event.eventBody.dealerContactModeItemSaved.map(item => {
            return item.id;
          });
          dispatch({
            type: actionTypes.UPDATE_DEALER_CONTACT_MODES_SUCCEEDED,
            dealerContactModes: event.eventBody.dealerContactModeItemSaved,
            key: key,
            ids: dealerContactModesIds
          });
          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_DEALER_CONTACT_MODES_FAILED,
            payload: { dealerContactModes, error: event },
            key: key
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_DEALER_CONTACT_MODES_FAILED,
          payload: { dealerContactModes, error },
          key: key
        });

        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function saveDealerContactInfos(partnerId, dealerId, dealerContactInfos, callbackFn = () => {}) {
  return async dispatch => {
    const key = combineKeys(partnerId, dealerId);
    dispatch({
      type: actionTypes.UPDATE_DEALER_CONTACT_INFOS_STARTED,
      payload: dealerContactInfos,
      key: key
    });
    dispatch(sendHttpRequest(api.saveDealerContactInfos(partnerId, dealerContactInfos), "saveDealerContactInfos"))
      .then(result => {
        const event = result.events.find(x => x.eventType === eventTypes.DEALER_CONTACT_INFOS_UPDATED);
        if (event) {
          const dealerContactInfoIds = event.eventBody.dealerContactInfoItem.map(item => {
            return item.id;
          });
          dispatch({
            type: actionTypes.UPDATE_DEALER_CONTACT_INFOS_SUCCEEDED,
            dealerContactInfos: event.eventBody.dealerContactInfoItem,
            key: key,
            ids: dealerContactInfoIds
          });
          dispatch({ type: actionTypes.UPDATE_PARTNER_SUCCEEDED, key: partnerId });
          dispatch({ type: actionTypes.PARTNER_LIST_INVALIDATED });
          callbackFn();
          dispatch(showEvent({ ...event, ok: true }));
        } else {
          dispatch({
            type: actionTypes.UPDATE_DEALER_CONTACT_INFOS_FAILED,
            payload: { dealerContactInfos, error: event },
            key: key
          });
          dispatch(showEvent({ ...event, correlationId: result.correlationId }));
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_DEALER_CONTACT_INFOS_FAILED,
          payload: { dealerContactInfos, error },
          key: key
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}


export function importPartnerBalanceSheet(balanceSheetId, file, callbackFn = () => {}) {
  return async dispatch => {
    await dispatch(sendHttpRequest(api.importPartnerBalanceSheet(balanceSheetId, file),"importPartnerBalanceSheet"))
      .then(_ => {
        callbackFn(false);
      })
      .catch(error => {
        callbackFn(true);
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function loadPropByCode(propCode) {
  return api.getPropertyByCode(propCode);
}


